import {Box, Center, Icon, Show, Spinner} from 'platform/foundation';
import {cn, cva} from 'platform/shared';

import {forwardRef, ForwardRefRenderFunction, useState} from 'react';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

import {LightboxImage} from '../types/LightboxImage';

interface ZoomImageComponentProps extends RequiredTestIdProps {
  image: LightboxImage;
}

const zoomImageVariants = cva(
  'relative h-full w-full max-h-none max-w-none select-none overflow-hidden object-contain will-change-transform [-webkit-touch-action:none] [-webkit-user-drag:none] [-webkit-user-select:none] [touch-action:none] [user-drag:none]'
);

const ZoomImageComponent: ForwardRefRenderFunction<HTMLImageElement, ZoomImageComponentProps> = (
  props,
  ref
) => {
  const [isLoading, setLoading] = useState<boolean>(true);
  const [isError, setError] = useState<boolean>(false);

  return (
    <>
      <img
        ref={ref}
        data-testid={suffixTestId('image', props)}
        draggable={false}
        src={props.image.url}
        alt={props.image.fileName ?? props.image.id}
        onLoad={() => {
          setLoading(false);
        }}
        onError={() => {
          setLoading(false);
          setError(true);
        }}
        loading="lazy"
        className={cn(zoomImageVariants())}
      />
      <Show when={isError}>
        <Box width="100%" height="100%" backgroundColor="general.transparent" ratio="4 / 3">
          <Center width="100%" height="100%">
            <Icon color="palettes.neutral.70.100" value="image/photo" size={6} />
          </Center>
        </Box>
      </Show>
      <Show when={isLoading}>
        <Box position="absolute" top={0} left={0} right={0} bottom={0}>
          <Center width="100%" height="100%">
            <Spinner color="light" />
          </Center>
        </Box>
      </Show>
    </>
  );
};

export const ZoomImage = forwardRef(ZoomImageComponent);
